
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acheter",
      function () {
        return require("private-next-pages/acheter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acheter"])
      });
    }
  